import { PRIORITY_META } from "../../lib/constants";
import type { Priority } from "../../lib/api";
import { cn } from "../../lib/cn";

export function PriorityBadge({
  priority,
  className,
  withDot = true,
}: {
  priority: Priority;
  className?: string;
  withDot?: boolean;
}) {
  const meta = PRIORITY_META[priority];
  if (!meta) return null;
  return (
    <span className={cn("badge", meta.text, meta.bg, meta.border, className)}>
      {withDot && <span className={cn("w-1.5 h-1.5 rounded-full", meta.dot)} />}
      {meta.label}
    </span>
  );
}
